"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _numeral = _interopRequireDefault(require("numeral"));
var _reactApexcharts = _interopRequireDefault(require("react-apexcharts"));
var _fr = _interopRequireDefault(require("apexcharts/src/locales/fr.json"));
var _moment = _interopRequireDefault(require("moment"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
_moment.default.locale('fr');
_numeral.default.locale('en');
class CandidateCountByAccountStatus extends _react.Component {
  state = {
    loading: false,
    candidates_count: 0,
    options: {
      chart: {
        locales: [_fr.default],
        defaultLocale: 'fr'
      },
      tooltip: {
        y: {
          formatter: value => value
        }
      }
    },
    candidate_count_series: [],
    initial_fetch: false
  };
  requests = {};
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchCandidateSeries();
  }
  fetchCandidateSeries() {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/candidate/get-candidate-count-by-support-status').then(function (xhr, response) {
      let stop_label = "Arrêt (" + response.candidate[0] + "/" + response.count + ')';
      let profesional_project_label = "Construction de projet professionnel (" + response.candidate[1] + "/" + response.count + ')';
      let company_create_label = "Création d'entreprise (" + response.candidate[2] + "/" + response.count + ')';
      let in_work_label = "En emploi (" + response.candidate[3] + "/" + response.count + ')';
      let in_formation_label = "En formation (" + response.candidate[4] + "/" + response.count + ')';
      let in_stage_label = "En stage (" + response.candidate[5] + "/" + response.count + ')';
      let keep_work_label = "Maintien en emploi (" + response.candidate[6] + "/" + response.count + ')';
      let break_label = "Pause (" + response.candidate[7] + "/" + response.count + ')';
      let searching_work_label = "Recherche d'emploi (" + response.candidate[8] + "/" + response.count + ')';
      let searching_formation_label = "Recherche de formation (" + response.candidate[9] + "/" + response.count + ')';
      let searching_stage_label = "Recherche de stage (" + response.candidate[10] + "/" + response.count + ')';
      let searching_alternance_label = "Recherche d'alternance (" + response.candidate[11] + "/" + response.count + ')';
      let reconversion_label = "Reconversion(" + response.candidate[12] + "/" + response.count + ')';
      let ending_label = "Terminé(" + response.candidate[13] + "/" + response.count + ')';
      let entretien_label = "Entretien préalable(" + response.candidate[14] + "/" + response.count + ')';
      let series_label = [stop_label, profesional_project_label, company_create_label, in_work_label, in_formation_label, in_stage_label, keep_work_label, break_label, searching_work_label, searching_formation_label, searching_stage_label, searching_alternance_label, reconversion_label, ending_label, entretien_label];
      component.setState({
        candidate_count_series: response.candidate,
        options: {
          ...state.options,
          labels: series_label
        },
        loading: false,
        candidates_count: response.count
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-carbon']
    }) : undefined;
    let output = /*#__PURE__*/_react.default.createElement(_Paper.default, {
      className: props.className,
      hidden: props.hidden
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-card"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-card__title"
    }, "R\xE9partition des candidats selon le statut d'accompagnement(Total : ", state.candidates_count, ")"), /*#__PURE__*/_react.default.createElement(_reactApexcharts.default, {
      options: state.options,
      series: state.candidate_count_series,
      type: "pie",
      height: "525"
    })), loader);
    return output;
  }
}
exports.default = CandidateCountByAccountStatus;
